export default __webpack_public_path__ + "static/media/liberum-13.e9cb2481.png";